export function showReadmoreButton() {
    document.querySelectorAll(".itemcardDescriptionWrapper").forEach(function(container) {
        const description = container.querySelector(".itemcardShortDescription");
        const readMoreLink = container.querySelector(".readmoreLink");

        if (!description || !readMoreLink) {
            return;
        }

        const contentHeight = description.scrollHeight;

        if (contentHeight > 200) {
            readMoreLink.style.display = "block";

            readMoreLink.addEventListener("click", function(e) {
                e.preventDefault();

                const isExpanded = description.classList.contains("expand");

                if (isExpanded) {
                    description.style.maxHeight = "110px";
                    description.classList.remove("expand");
                    readMoreLink.classList.remove("expand");
                } else {
                    description.style.maxHeight = `${contentHeight}px`;
                    description.classList.add("expand");
                    readMoreLink.classList.add("expand");
                }
            });
        } else {
            description.style.transition = "none";

            const style = window.getComputedStyle(description, "::after");
            const transitionAfter = style.transition;
            description.style.setProperty("--after-transition", "none");

            description.classList.add("expand");
            description.style.maxHeight = "none";
            readMoreLink.style.display = "none";
        }
    });

    document.querySelectorAll(".itemcardWarning").forEach(function(container) {
        const description = container.querySelector(".itemcardWarning__description");
        const readMoreLink = container.querySelector(".readmoreLink");

        if (!description || !readMoreLink) {
            return;
        }

        const contentHeight = description.scrollHeight;
        const collapsedHeight = 40;

        if (contentHeight > collapsedHeight) {
            readMoreLink.style.display = "block";

            readMoreLink.addEventListener("click", function(e) {
                e.preventDefault();

                const isExpanded = description.classList.contains("expand");

                if (isExpanded) {
                    description.style.maxHeight = `${collapsedHeight}px`;
                    description.classList.remove("expand");

                    description.addEventListener(
                        "transitionend",
                        function handleTransitionEnd() {
                            description.style.webkitLineClamp = 2;
                            description.removeEventListener("transitionend", handleTransitionEnd);
                        }
                    );

                    readMoreLink.classList.remove("expand");
                } else {
                    description.style.webkitLineClamp = "unset";
                    description.style.maxHeight = `${contentHeight}px`;
                    description.classList.add("expand");
                    readMoreLink.classList.add("expand");
                }
            });

            description.style.maxHeight = `${collapsedHeight}px`;
        } else {
            description.style.transition = "none";
            description.classList.add("expand");
            description.style.maxHeight = "none";
            readMoreLink.style.display = "none";
        }
    });
}
